import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  GET_TAI_SAN_THEO_CHO_VAY_TMCD,
  GET_TAI_SAN_THUOC_TINH_TMCD,
  GET_LOAI_TAI_SAN_TMCD,
  GET_CONFIG_SYS_TMCD,
  SHOW_FORM_CAM_DO,
  GET_LIST_TAI_SAN_CAM_CO_TM_LOAI_TAISAN,
  POST_CAM_DO,
  CHECK_EDIT_CUSTOMER,
  CHECK_EDIT_CHO_VAY,
} from "actions/ThemMoiCamDo/actionTypes";
import {
  setTaiSanCamCo,
  setThuocTinhTaiSan,
  setListTaiSanCamCo,
  setListLoaiTaiSan,
  getThuocTinhTaiSanTMCD as a_getThuocTinhTaiSanTMCD,
  getConfigSysTMCD,
  getLoaiTaiSanTMCD as a_getLoaiTaiSanTMCD,
  getTaiSanTheoChoVayTMCD as a_getTaiSanTheoChoVayTMCD,
  setListLoaiTaiSanReloadTMLTS,
  postCamDoFailure,
  postCamDoSuccess,
  checkEditChoVay as a_checkEditChoVay,
  setEnableEditChoVay,
} from "actions/ThemMoiCamDo";
import TaiSanApi from "service/taiSanApi";
import { pushNotification } from "utils/notifications";
import ThuocTinhTaiSanApi from "service/thuocTinhTaiSanApi";
import LoaiTaiSanApi from "service/loaiTaiSanApi";
import { setConfig } from "actions/ThemMoiCamDo";
import CauHinhApi from "service/cauHinhApi";
import { getListPhiKhac, getListPhiKhacTheoChoVay } from "actions/PhiKhac";
import { getListPhiKhacHangKy, getListPhiKhacHangKyTheoChoVay } from "actions/PhiKhacHangKy";
import { getComboNguonKhachHang } from "actions/NguonKhachHang";
import { getComboStore } from "actions/Store";
import CamDoApi from "service/camDoApi";
import CustomerApi from "service/customerApi";
import { setEnableEditCustomer } from "actions/ThemMoiCamDo";

function* showFormCamDo(action) {
  try {
    yield put(getComboNguonKhachHang());
    yield put(getComboStore());
    if (action.payload && action.payload.ChoVayId) {
      let chovay = action.payload;
      yield put(a_checkEditChoVay(chovay.ChoVayId));
      yield put(
        getListPhiKhacTheoChoVay({
          chovayId: chovay.ChoVayId,
          typeChoVay: chovay.Type,
        })
      );
      yield put(
        getListPhiKhacHangKyTheoChoVay({
          chovayId: chovay.ChoVayId,
          typeChoVay: chovay.Type,
        })
      );
      yield put(
        a_getLoaiTaiSanTMCD({ loaiTaiSan: "", notloadThuocTinh: true })
      );
      yield put(a_getTaiSanTheoChoVayTMCD({ chovayId: chovay.ChoVayId }));
    } else {
      yield put(setTaiSanCamCo({}));
      yield put(setListTaiSanCamCo([]));
      yield put(
        a_getLoaiTaiSanTMCD({ loaiTaiSan: "", notloadThuocTinh: false })
      );
      yield put(getListPhiKhac({ type: 3 }));
      yield put(getListPhiKhacHangKy({ type: 3 }));
    }
  } catch (error) {}
}
function* getTaiSanTheoChoVayTMCD(action) {
  try {
    const response = yield call(TaiSanApi.taiSanTheoChoVay, action.dataSearch);
    if (response.ok && response.data) {
      let lstCamDo = response.data;
      if (lstCamDo.length > 0) {
        yield put(setTaiSanCamCo(lstCamDo[0]));
        yield put(
          getConfigSysTMCD({
            loaiTaiSan: lstCamDo[0].LoaiTaiSan,
          })
        );
        yield put(setThuocTinhTaiSan(lstCamDo[0].ThuocTinhTaiSan));
      }
      if (lstCamDo.length > 1) {
        lstCamDo.splice(0, 1);
        yield put(setListTaiSanCamCo(lstCamDo));
      }
    } else {
      pushNotification(
        "Không tải được thông tin tài sản cầm cố.",
        "error",
        "TOP_CENTER",
        1000
      );
    }
  } catch (error) {
    pushNotification(
      "Không tải được thông tin tài sản cầm cố.",
      "error",
      "TOP_CENTER",
      1000
    );
  }
}

function* getThuocTinhTaiSanTMCD(action) {
  try {
    const response = yield call(ThuocTinhTaiSanApi.list, action.dataSearch);
    if (response.ok) {
      yield put(setThuocTinhTaiSan(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
  }
}

function* getLoaiTaiSanTMCD(action) {
  try {
    const response = yield call(LoaiTaiSanApi.combo, action.dataSearch);
    if (response.ok) {
      yield put(setListLoaiTaiSan(response.data));
      if (response.data && response.data.length > 0) {
        if (action.dataSearch && !action.dataSearch.notloadThuocTinh) {
          yield put(
            a_getThuocTinhTaiSanTMCD({
              loaiTaiSan: response.data[0].value,
            })
          );
          yield put(
            getConfigSysTMCD({
              loaiTaiSan: response.data[0].value,
            })
          );
        }
      }
    } else {
      pushNotification(
        "Không tải được danh sách loại tài sản",
        "error",
        "TOP_CENTER",
        1000
      );
    }
  } catch (error) {
    pushNotification(
      "Không tải được danh sách loại tài sản",
      "error",
      "TOP_CENTER",
      1000
    );
  }
}
function* getLoaiTaiSanTMCD_ReloadTMLoaiTaiSan(action) {
  try {
    const response = yield call(LoaiTaiSanApi.combo, action.dataSearch);
    if (response.ok) {
      yield put(setListLoaiTaiSanReloadTMLTS(response.data));
      if (response.data && response.data.length > 0) {
        if (action.dataSearch && !action.dataSearch.notloadThuocTinh) {
          yield put(
            a_getThuocTinhTaiSanTMCD({
              loaiTaiSan: response.data[response.data.length - 1].value,
            })
          );
          yield put(
            getConfigSysTMCD({
              loaiTaiSan: response.data[response.data.length - 1].value,
            })
          );
        }
      }
    } else {
      pushNotification(
        "Không tải được danh sách loại tài sản",
        "error",
        "TOP_CENTER",
        1000
      );
    }
  } catch (error) {
    pushNotification(
      "Không tải được danh sách loại tài sản",
      "error",
      "TOP_CENTER",
      1000
    );
  }
}
function* getConfigSysThemMoiCamDo(action) {
  try {
    const response = yield call(
      CauHinhApi.getConfigSys_LoaiTaiSan,
      action.dataSearch
    );
    if (response.ok && response.data) {
      yield put(setConfig(response.data));
    }
  } catch (error) {
    console.log(error);
  }
}
function* postCamDo(action) {
  try {
    const response = yield call(CamDoApi.addAndEdit, action.dataPost);
    if (response.ok) {
      if (response.data.Error) {
        yield put(postCamDoFailure(response.data));
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
      } else {
        yield put(postCamDoSuccess(response.data));
        pushNotification(response.data.Message, "success", "TOP_CENTER", 2000);
      }
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(postCamDoFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(postCamDoFailure());
  }
}

function* checkEditChoVay(action) {
  try {
    const response = yield call(CamDoApi.checkEditChoVay, action.choVayId);
    if (response.ok) {
      yield put(setEnableEditChoVay(response.data));
    } else {
      console.log(response);
    }
  } catch (error) {
    console.log(error);
  }
}
function* checkEditCustomer(action) {
  try {
    const response = yield call(
      CustomerApi.checkEditCustomer,
      action.customerId
    );
    if (response.ok) {
      yield put(setEnableEditCustomer(response.data));
    } else {
      console.log(response);
    }
  } catch (error) {
    console.log(error);
  }
}
function* watchGetRequest() {
  yield takeLatest(GET_TAI_SAN_THEO_CHO_VAY_TMCD, getTaiSanTheoChoVayTMCD);
  yield takeLatest(GET_TAI_SAN_THUOC_TINH_TMCD, getThuocTinhTaiSanTMCD);
  yield takeLatest(GET_LOAI_TAI_SAN_TMCD, getLoaiTaiSanTMCD);
  yield takeLatest(GET_CONFIG_SYS_TMCD, getConfigSysThemMoiCamDo);
  yield takeLatest(SHOW_FORM_CAM_DO, showFormCamDo);
  yield takeLatest(
    GET_LIST_TAI_SAN_CAM_CO_TM_LOAI_TAISAN,
    getLoaiTaiSanTMCD_ReloadTMLoaiTaiSan
  );
  yield takeLatest(POST_CAM_DO, postCamDo);
  yield takeLatest(CHECK_EDIT_CHO_VAY, checkEditChoVay);
  yield takeLatest(CHECK_EDIT_CUSTOMER, checkEditCustomer);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
